//Imports
import React, { useCallback, useEffect } from "react";

//Controls
import { Button, Modal } from "@gpstrackit/gtc-react-controls";

//Components
import { NotificationManager, NotificationContainer } from "Components/Notifications";

//Hooks
import { useIntl } from "react-intl";
import { useDispatch, useSelector } from "react-redux";

//Actions
import { manageDeleteManageTemperature, reset } from "./redux/slice";

const DeleteManageTemperature = ({ refresh }) => {
  //Redux
  const dispatch = useDispatch();
  const { open, loading, result, error, deleteTemperatureList } = useSelector(
    (state) => state.manageDeleteManageTemperatureRedux
  );

  //Language
  const { messages } = useIntl();

  //Handlers and utils
  const handleClose = useCallback(() => { 
    dispatch(reset());
  }, []);
  const handleDeleteSubmit = useCallback(() => {
    dispatch(manageDeleteManageTemperature({ items: deleteTemperatureList }));
  }, [deleteTemperatureList]);

  //Effects
  useEffect(() => {
    if (!error) return;
    NotificationManager.error(
      error?.error || messages["errorMessage"],
      messages["error"],
      3000,
      null,
      null,
      "error"
    ); 
  }, [error]);

  useEffect(() => {
    if (!result) return;
    const messageSuccess =
      !deleteTemperatureList?.length > 0
        ? messages["manage_deletedTemperature"]
        : messages["manage_deletedTemperatures"];
    NotificationManager.success(messageSuccess, messages["success"], 3000, null, null, "success");
    refresh();
    dispatch(reset());
  }, [result, deleteTemperatureList]);
  return (
    <Modal
      title={
        !deleteTemperatureList?.length > 0
          ? messages["manage_deleteManageTemperature_deleteTemperature"]
          : messages["manage_deleteManageTemperature_deleteTemperatures"]
      }
      size="small"
      open={open}
      handleClose={handleClose}
      loading={loading}
      footer={
        <div>
          <Button
            variant="secondary"
            style={{ marginRight: "5px" }}
            onClick={() => handleClose()}
            isDisabled={loading}
          >
            {messages["cancel"]}
          </Button>
          <Button variant="warning" onClick={() => handleDeleteSubmit()} isDisabled={loading}>
            {messages["delete"]}
          </Button>
        </div>
      }
    >
      <div style={{ padding: "10px 25px" }}>
        <p>{messages["manage_deleteManageTemperature_confirmationMessage"]}</p>
        <ul>
          {deleteTemperatureList.map((temperature) => (
            <li>{temperature.label}</li>
          ))}
        </ul>
      </div>
      <NotificationContainer />
    </Modal>
  );
};

export default DeleteManageTemperature;
